import type { FaireProductEntity } from "../../entity_types/product";

export const p_93mvn7w4pf: FaireProductEntity = {
  token: "p_93mvn7w4pf",
  type: "product",
  name: "Embroidered California Pouch",
  brandToken: "b_c5lwttyyt1",
  brandName: "Tomoko Maruyama",
  imageUrl:
    "https://cdn.faire.com/fastly/8d56a8eb1436d7625546c4d475f95d9d8d9f2115703a9d81386f0d38b07fb59f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf50c9986cfc3c0f5851868783686e2c75e2d0b0f376285f2759be8060a6cc68.jpeg",
    "https://cdn.faire.com/fastly/b6f493e5276a19eec91c6459760e17939132a8640ff129c9ad3e2bb75b91b4cd.jpeg",
    "https://cdn.faire.com/fastly/ed2834da88efb220fc21906cbe31de16cdff31cf85dcf775d630d79f0b75b9cb.jpeg",
    "https://cdn.faire.com/fastly/5dd8983cdb0365fb9a3a9ee0408dac0f7736fb0170ab59d06c4e6d7bba06a44e.jpeg",
  ],
  priceDollars: 15.25,
  description:
    "There are lots of California symbols and landmarks on this pouch. You can touch and feel the texture of the beautiful threads. Each thread color was carefully selected by the artist to capture the California spirit.\n\n• 9”x6”\n• 100% Cotton Canvas\n• 12oz thick very durable fabric\n• Protective inner fabric\n• Gold color zipper",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:59.291Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
